// import React, { useContext, useState } from "react";
// import stylesSelected from "./Community.module.css";
// import { HomePageContext } from "../../store/HomePageContext";
// import Carou from "./Carou/Carou";
// import { FaPlay, FaPause, FaExpand, FaVolumeMute, FaVolumeUp } from 'react-icons/fa';
// import Hero from "./Hero.webp"

// const CarouselCommunity = () => {
//   const { homeScreenDetails } = useContext(HomePageContext);
//   const communityTitle = homeScreenDetails?.maflamCommunityTitle?.title || "Community Stories";
//   const communityData = homeScreenDetails?.maflamCommunityData || [];
//   const [isPlaying, setIsPlaying] = useState({});
//   const [isMuted, setIsMuted] = useState({});
//   const [videoErrors, setVideoErrors] = useState({});

//   // Handle video play/pause with error handling
//   const handleVideoPlayPause = (index, video) => {
//     if (isPlaying[index]) {
//       video.pause();
//       setIsPlaying(prev => ({...prev, [index]: false}));
//     } else {
//       video.play().catch(err => {
//         console.error("Video playback failed:", err);
//         setVideoErrors(prev => ({...prev, [index]: true}));
//       });
//       setIsPlaying(prev => ({...prev, [index]: true}));
//     }
//   };

//   // Handle video errors
//   const handleVideoError = (index) => {
//     setVideoErrors(prev => ({...prev, [index]: true}));
//     setIsPlaying(prev => ({...prev, [index]: false}));
//   };

//   const videoItems = communityData.map((story, index) => ({
//     id: index,
//     content: (
//       <div className={stylesSelected.videoContainer}>
//         {videoErrors[index] ? (
//           <img
//             src={Hero}
//             alt="Community Story"
//             className={stylesSelected.fallbackImage}
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               borderRadius: "8px"
//             }}
//           />
//         ) : (
//           <>
//             <video
//               src={story.videoUrl}
//               className={stylesSelected.video}
//               loop
//               playsInline
//               muted={isMuted[index]}
//               poster={Hero}
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//                 borderRadius: "8px"
//               }}
//               onPlay={() => setIsPlaying(prev => ({...prev, [index]: true}))}
//               onPause={() => setIsPlaying(prev => ({...prev, [index]: false}))}
//               onError={() => handleVideoError(index)}
//             />
//             <div className={stylesSelected.videoControls}>
//               <button
//                 className={`${stylesSelected.playButton} ${isPlaying[index] ? stylesSelected.hideButton : ''}`}
//                 onClick={(e) => {
//                   const video = e.currentTarget.parentElement.parentElement.querySelector('video');
//                   handleVideoPlayPause(index, video);
//                 }}
//               >
//                 {isPlaying[index] ? <FaPause size={30} /> : <FaPlay size={30} />}
//               </button>
//               <button
//                 className={stylesSelected.muteButton}
//                 onClick={(e) => {
//                   const video = e.currentTarget.parentElement.parentElement.querySelector('video');
//                   video.muted = !video.muted;
//                   setIsMuted(prev => ({...prev, [index]: !prev[index]}));
//                 }}
//               >
//                 {isMuted[index] ? <FaVolumeMute size={20} /> : <FaVolumeUp size={20} />}
//               </button>
//               <button
//                 className={`${stylesSelected.expandButton} ${!isPlaying[index] ? stylesSelected.hideButton : ''}`}
//                 onClick={(e) => {
//                   const video = e.currentTarget.parentElement.parentElement.querySelector('video');
//                   if (video.requestFullscreen) {
//                     video.requestFullscreen();
//                   }
//                 }}
//               >
//                 <FaExpand size={20} />
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     ),
//   }));

//   return (
//     <div className={stylesSelected.carouselWrapper}>
//       <h2>{communityTitle}</h2>
//       <Carou
//         itemWidth={400}
//         itemHeight={300}
//         items={videoItems}
//         margin={50}
//       />
//     </div>
//   );
// };

// export default CarouselCommunity;

import React, { useContext, useState } from "react";
import stylesSelected from "./Community.module.css";
import { HomePageContext } from "../../store/HomePageContext";
import Carou from "./Carou/Carou";
import {
  FaPlay,
  FaPause,
  FaExpand,
  FaVolumeMute,
  FaVolumeUp,
} from "react-icons/fa";

const CarouselCommunity = () => {
  const { homeScreenDetails } = useContext(HomePageContext);
  const communityTitle =
    homeScreenDetails?.maflamCommunityTitle?.title || "Community Stories";
  const communityData = homeScreenDetails?.maflamCommunityData || [];
  const [isPlaying, setIsPlaying] = useState({});
  const [isMuted, setIsMuted] = useState({});

  const videoItems = communityData.map((story, index) => ({
    id: index,
    content: (
      <div className={stylesSelected.videoContainer}>
        <video
          src={story.videoUrl}
          className={stylesSelected.video}
          loop
          playsInline
          muted={isMuted[index]}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "8px",
          }}
          onPlay={() => setIsPlaying((prev) => ({ ...prev, [index]: true }))}
          onPause={() => setIsPlaying((prev) => ({ ...prev, [index]: false }))}
        />
        <div className={stylesSelected.videoControls}>
          <button
            className={`${stylesSelected.playButton} ${
              isPlaying[index] ? stylesSelected.hideButton : ""
            }`}
            onClick={(e) => {
              const video =
                e.currentTarget.parentElement.parentElement.querySelector(
                  "video"
                );
              if (isPlaying[index]) {
                video.pause();
              } else {
                video.play();
              }
            }}
          >
            {isPlaying[index] ? <FaPause size={30} /> : <FaPlay size={30} />}
          </button>
          <button
            className={stylesSelected.muteButton}
            onClick={(e) => {
              const video =
                e.currentTarget.parentElement.parentElement.querySelector(
                  "video"
                );
              video.muted = !video.muted;
              setIsMuted((prev) => ({ ...prev, [index]: !prev[index] }));
            }}
          >
            {isMuted[index] ? (
              <FaVolumeMute size={20} />
            ) : (
              <FaVolumeUp size={20} />
            )}
          </button>
          <button
            className={`${stylesSelected.expandButton} ${
              !isPlaying[index] ? stylesSelected.hideButton : ""
            }`}
            onClick={(e) => {
              const video =
                e.currentTarget.parentElement.parentElement.querySelector(
                  "video"
                );
              if (video.requestFullscreen) {
                video.requestFullscreen();
              }
            }}
          >
            <FaExpand size={20} />
          </button>
        </div>
      </div>
    ),
  }));

  return (
    <div className={stylesSelected.carouselWrapper}>
      <h2>{communityTitle}</h2>
      <Carou itemWidth={400} itemHeight={300} items={videoItems} margin={50} />
    </div>
  );
};

export default CarouselCommunity;
